import type {
  FetchUserNotificationsParams,
  NotificationsQueryKey,
  NotificationsQuerySuffix,
  UseGetUserNotificationsProps,
} from "./notifications.type";
import type { NotificationEntity } from "@/entities/notification";

import { useInfiniteList } from "@/hooks/queries";

import { NOTIFICATIONS_PER_PAGE } from "./notifications.constant";

export const useGetUserNotifications = ({
  readState,
  queryKeySuffix,
}: UseGetUserNotificationsProps = {}) => {
  const suffix: NotificationsQuerySuffix = queryKeySuffix ?? readState ?? "all";
  const queryKey: NotificationsQueryKey = ["notifications", suffix];

  const params: FetchUserNotificationsParams = {
    "page[size]": NOTIFICATIONS_PER_PAGE,
    "filter[read_state]": readState,
  };

  const { data, ...queryResult } = useInfiniteList<NotificationEntity>({
    endpoint: "user.notifications",
    queryKey,
    params,
  });

  return {
    notifications: data ?? [],
    ...queryResult,
  };
};

export const useGetNotificationsUnreadCount = () => {
  const { notifications, isLoading } = useGetUserNotifications({
    readState: "unread",
    queryKeySuffix: "unread_count",
  });

  return {
    unreadCount: notifications.length,
    isLoading,
  };
};
